/**
 * Home Loan tab — extracted home loan accounts.
 * Uploads live on the dedicated Upload Documents tab.
 */
import { Card, CardContent, Skeleton } from '@finmin/ui';
import { HomeIcon } from 'lucide-react';
import { useExtractedProfile } from '@/api/profile-documents';
import { HomeLoanCard } from '@/features/home-loan/home-loan-card';

export function HomeLoanTab() {
  const { data, isLoading } = useExtractedProfile();
  const loans = data?.home_loans ?? [];

  if (isLoading) {
    return <Skeleton className="h-64 w-full rounded-xl" />;
  }
  if (loans.length === 0) {
    return <EmptyState />;
  }
  return (
    <div className="space-y-5">
      {loans.map((l) => (
        <HomeLoanCard key={l.id} loan={l} />
      ))}
    </div>
  );
}

function EmptyState() {
  return (
    <Card>
      <CardContent className="py-10 text-center">
        <HomeIcon
          className="mx-auto h-10 w-10 text-muted-foreground/60"
          aria-hidden
        />
        <p className="mt-3 text-sm font-medium text-foreground">
          No home loan on file
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          Head to the <span className="font-medium text-foreground">Upload Documents</span>{' '}
          tab to add your sanction letter, welcome kit, or statement of account.
          We'll surface your EMI, interest type, and charge structure here.
        </p>
      </CardContent>
    </Card>
  );
}
